import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import classnames from 'classnames'

import ManuallyEnteredKeywordsSectionPreview from './ManuallyEnteredKeywordsSectionPreview'
import NegativeKeywordsListSectionPreview from './NegativeKeywordsListSectionPreview'

import { dv360TargetingSelector } from '../../../../../../../modules/selectors/dv360Constants'

import { targetingTypes } from '../../../../LineItemDv360Create/fields'

import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const CategoriesAndKeywordsSectionPreview = () => {
  const { t } = useTranslation()

  const classes = useStyles()

  const drawerFormClasses = useDrawerFormStyles()

  const targeting = useSelector(dv360TargetingSelector)

  const categoriesNames = useMemo(() => {
    return targeting
      .filter(option => option.type === targetingTypes.TARGETING_TYPE_CATEGORY && !option.negative)
      .map(option => option.display_name)
  }, [targeting])

  const excludedCategoriesNames = useMemo(() => {
    return targeting
      .filter(option => option.type === targetingTypes.TARGETING_TYPE_CATEGORY && option.negative)
      .map(option => option.display_name)
  }, [targeting])

  const manuallyEnteredKeywords = useMemo(() => {
    return targeting.filter(option => option.type === targetingTypes.TARGETING_TYPE_KEYWORD)
  }, [targeting])

  const negativeKeywordsListsTargetingOptions = useMemo(() => {
    return targeting.filter(option => option.type === targetingTypes.TARGETING_TYPE_NEGATIVE_KEYWORD_LIST)
  }, [targeting])

  return (
    <>
      {(categoriesNames.length > 0 || excludedCategoriesNames.length > 0) && (
        <section className={classnames(drawerFormClasses.section, classes.categoriesSection)}>
          {categoriesNames.length > 0 && (
            <>
              <h3 className={drawerFormClasses.sectionTitle}>{t('Categories')}</h3>
              {categoriesNames.map(categoryName => (
                <p>{categoryName}</p>
              ))}
            </>
          )}

          {excludedCategoriesNames.length > 0 && (
            <>
              <h3 className={classnames(drawerFormClasses.sectionTitle, classes.excludeCategoriesTitle)}>
                {t('Excluded categories')}
              </h3>
              {excludedCategoriesNames.map(categoryName => (
                <p>{categoryName}</p>
              ))}
            </>
          )}
        </section>
      )}

      {manuallyEnteredKeywords.length > 0 && <ManuallyEnteredKeywordsSectionPreview />}
      {negativeKeywordsListsTargetingOptions.length > 0 && <NegativeKeywordsListSectionPreview />}
    </>
  )
}

export default CategoriesAndKeywordsSectionPreview
